import React, { useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';
import Section from '../../common/Section';
import bg from './../../../assets/img/illustrations/corner-4.png';
import ButtonIcon from '../../common/ButtonIcon';
import { faUndo } from '@fortawesome/free-solid-svg-icons';
import { useHistory, useParams } from 'react-router';
import serviceList from '../../../helpers/data/feature/serviceList';
import { PreloadState } from '../../UI/preloading/PreloadState';

const ServiceDetail = () => {

    const history = useHistory();
    const { id } = useParams();
    const [loading, setLoaging] = useState(true);
    const [data, setData] = useState({});
    const { media, subtitle, title, description, details } = data;

    useEffect(() => {
        setData(serviceList[Number(id) - 1]);
        setTimeout(() => { setLoaging(false); }, 1000);
    }, [id]);

    return <>
        <Section image={bg} className="d-flex text-center align-items-center justify-content-center py-0 vh-100" style={{ backgroundSize: 'cover' }} position="center bottom">
            <PreloadState loading={loading}>
                <Row className="min-vh-100 align-items-center row py-5 py-md-0">
                    <Col sm={12}>
                        <Row className="justify-content-center text-center">
                            <Col lg={8} xl={7} xxl={6} className="col-xxl-6">
                                <h1 className="fs-1 fs-sm-2 fs-md-3">{title && title}</h1>
                                <p className="lead fs--1">{description && description}</p>
                            </Col>
                        </Row>
                        <Row className='mt-4'>
                            <Col sm={4} className=''>
                                <img width={'60%'} src={media?.src} alt='detail' />
                            </Col>
                            <Col sm={8} className='px-5'>
                                <Row>
                                    <Col sm={12} className='text-left'>
                                        <h3>{subtitle && subtitle}</h3>
                                    </Col>
                                    <Col sm={12} className='text-left fs--1'>
                                        <p dangerouslySetInnerHTML={{ __html: details && details }}></p>
                                    </Col>
                                    <Col sm={12} className='text-left'>
                                        <ButtonIcon
                                            color="falcon-default"
                                            className="px-5 mr-2"
                                            icon={faUndo}
                                            onClick={() => history.goBack()}
                                            iconAlign="right"
                                            transform="down-1 shrink-4"
                                            size='sm'
                                        >
                                            Volver
                                        </ButtonIcon>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </PreloadState>
        </Section>
    </>
}

export default ServiceDetail;